import { Badge } from '@/shared/components/ui/badge'
import { BUSINESS_STATUS_LABELS, labelOf } from '@/shared/constants'

type StatusVariant = 'active' | 'inactive' | 'cancelled' | 'pending'

// La etiqueta sale del módulo central de traducciones; aquí solo el color.
const STATUS_VARIANT: Record<string, StatusVariant> = {
  APPROVED: 'active',
  USSED: 'active',
  PAUSE: 'inactive',
  SERVICE_CANCELLED: 'cancelled',
  NOT_INTERESTED: 'cancelled',
  POTENTIAL: 'pending',
  INITIAL_EVALUATION: 'pending',
  DEEP_EVALUATION: 'pending',
  PENDING_APPROVAL: 'pending',
  PLANNING: 'pending',
  INSTALLATION: 'pending',
  IN_DEPLOY: 'pending',
  DEVELOPMENT: 'pending',
  // Alias legacy.
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELLED: 'cancelled',
  CANCELED: 'cancelled',
  PENDING: 'pending',
}

interface BusinessStatusBadgeProps {
  status: string
}

export function BusinessStatusBadge({ status }: BusinessStatusBadgeProps) {
  const variant = STATUS_VARIANT[status?.toUpperCase() ?? ''] ?? 'inactive'
  return <Badge variant={variant}>{labelOf(BUSINESS_STATUS_LABELS, status)}</Badge>
}
